const margin = { top: 20, left: 150, bottom: 30, right: 150 }
const width = window.innerWidth - margin.left - margin.right
// const height = window.innerHeight - margin.top - margin.bottom
const height = 30000
const node_radius = 8
const text_position = 13

export { margin, width, height, node_radius, text_position }
